@if (!submitting() && submittingSuccess()) {
<app-review-success-step></app-review-success-step>
} @else {
<section [formGroup]="formGroup!" ngxsForm="codDetail.managerReviewForm">
    <h2 class="text-base font-bold text-font-primary">Manager Review</h2>
    <p class="text-xs text-font-secondary">Enter any missing information or update the existing information below.</p>
    <div class="max-w-input flex flex-col gap-2 mt-4">
        <sag-ui-select [required]="true" label="Related Manager Review" formControlName="relatedManagerReview">
            @for (option of basicReviewResult | keyvalue; track $index) {
            <sag-ui-option [value]="option.value">{{ option.value }}</sag-ui-option>
            }
        </sag-ui-select>
        @if (formGroup.controls.relatedManagerReview.value === reviewResult.DECLINED) {
        <sag-ui-textarea
            [required]="true"
            label="Reason for Denial"
            formControlName="reasonForDenial"
        ></sag-ui-textarea>
        <sag-ui-select [required]="true" label="Select Next Step:" formControlName="nextStep">
            @for (option of nextSteps | keyvalue; track $index) {
            <sag-ui-option [value]="option.value">{{ option.value }}</sag-ui-option>
            }
        </sag-ui-select>
        }
    </div>
    @if (!disabled) {
    <sag-ui-button
        icon="checkmark-large"
        size="sm"
        class="mt-4"
        [disabled]="invalid"
        [loading]="submitting()"
        (click)="submit()"
        >Save</sag-ui-button
    >
    }
</section>
}
